import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

import { Tab } from '@cred/react-tabs'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import Dropdown from '@cred/react-basic-form-fields/Dropdown'

import { IS_BANKRATE_IFRAME_ENABLED } from 'utils/featureToggle/toggles'
import Tabs from 'components/tabs'
import { useViewport } from 'components/hooks'
import InitialValuesContext from 'components/initial-values-context'

import { HYSRateTableBankrate } from '../../high-yield-savings'
import { getOptions, getTabContent, getTabName, onTabClicked } from './utils'
import styles from './styles.module.scss'

const useBankrateIframe = () => {
  const [loadIframe, setLoadIframe] = useState(false)
  const [showIframe, setShowIframe] = useState(false)

  const updateIframe = (vertical) => {
    if (vertical === 'high-yield-savings') {
      setLoadIframe(true)
      setShowIframe(true)
    } else {
      setShowIframe(false)
    }
  }

  return IS_BANKRATE_IFRAME_ENABLED
    ? { loadIframe, showIframe, updateIframe }
    : { updateIframe: () => {} }
}

const VerticalTabsSection = ({
  vertical,
  verticals,
  setVertical,
  theme,
  trackSnowplowEvent,
  ...props
}) => {
  const { initialValues: partnerFormData } = useContext(InitialValuesContext)

  const { width } = useViewport()
  const isMobile = width < 568

  const { loadIframe, showIframe, updateIframe } = useBankrateIframe()

  return (
    <div className={styles.tabsContainer}>
      <section className="hidden-xs">
        <Tabs
          type="flat"
          activeTab={verticals.indexOf(vertical)}
          onTabClick={onTabClicked(verticals, setVertical, trackSnowplowEvent, updateIframe)}
          branding={{
            tabHeader: 'tab-header',
            tabContent: 'tab-content',
            tabItem: 'tab-item',
            tabItemWrapper: 'tab-item-wrapper',
            tabActive: 'tab-active',
          }}
        >
          {verticals.map((validVertical) => (
            <Tab key={validVertical} title={getTabName(validVertical)}>
              {!isMobile &&
                getTabContent(validVertical, { ...props, initialValues: partnerFormData, theme })}
            </Tab>
          ))}
        </Tabs>
      </section>
      <section className={`${styles.mobileDropdown} hidden-sm hidden-md hidden-lg hidden-xl`}>
        <Dropdown
          name="vertical"
          label="Compare rates for..."
          id="verticals-dropdown"
          placeholder="Select a product"
          initialValue={verticals[0]}
          inputProps={{
            onChange: (e) => {
              const { value } = e.target
              setVertical(value)
              updateIframe(value)
            },
          }}
        >
          {getOptions(verticals).map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Dropdown>
        <div className="mt-8">
          {isMobile && getTabContent(vertical, { ...props, initialValues: partnerFormData, theme })}
        </div>
      </section>
      {IS_BANKRATE_IFRAME_ENABLED && loadIframe && <HYSRateTableBankrate showIframe={showIframe} />}
    </div>
  )
}

VerticalTabsSection.propTypes = {
  vertical: PropTypes.string,
  setVertical: PropTypes.func,
  verticals: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  theme: PropTypes.string,
  trackSnowplowEvent: PropTypes.func,
}

export { VerticalTabsSection }

export default withSnowplowContexts(VerticalTabsSection)
